import { Component } from '@angular/core';

@Component({
  selector: 'file360-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor() {

  }
}
